const MODULE_NAME = "SCHEDULED_VISITES_";
const FETCH_STARTED = MODULE_NAME + 'FETCH_STARTED';
const FETCH_COMPLETED = MODULE_NAME + 'FETCH_COMPLETED';
const FETCH_ENTRY_STARTED = MODULE_NAME + 'FETCH_ENTRY_STARTED';
const FETCH_ENTRY_COMPLETED = MODULE_NAME + 'FETCH_ENTRY_COMPLETED';

export {
  FETCH_STARTED,
  FETCH_COMPLETED,
  FETCH_ENTRY_STARTED,
  FETCH_ENTRY_COMPLETED
};
